const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
export const forcedTimezone = tz
